import React from 'react';
import {
  UncontrolledCollapse,
  Button,
  InputGroup,
  InputGroupAddon,
  Input,
} from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';

const columns = [
  {
    dataField: 'name',
    text: 'Name',
  },
  {
    dataField: 'groupName',
    text: 'Group',
  },
  {
    dataField: 'location',
    text: 'Location',
  },
  {
    dataField: 'alarmType',
    text: 'Alarm Type',
    formatter: (cell) => (cell ? 'Yes' : 'No'),
    filterValue: (cell) => (cell ? 'Yes' : 'No'),
  },
  {
    dataField: 'timeDetected',
    text: 'Time Detected',
    isDateTime: true,
  },
  {
    dataField: 'units',
    text: 'Units',
  },
  {
    dataField: 'textValue',
    text: 'textValue',
  },
  {
    dataField: 'alarmPriority',
    text: 'Alarm Priority',
  },
];

function MobileSearch(props) {
  const inputRef = React.useRef(null);
  function afterSearch(newResult) {
    const filteredSensorIds = [];
    newResult.forEach((element) => {
      filteredSensorIds.push(element.sensorId);
    });
    props.onSearch(filteredSensorIds);
  }
  return (
    <div>
      <Button
        color="primary"
        id="mobileSearch"
        style={{ width: '100%', borderRadius: 0, padding: '6px 0px' }}
      >
        {inputRef.current && inputRef.current.value
          ? `Filtered by: ` + inputRef.current.value
          : 'No Filter'}
      </Button>
      <UncontrolledCollapse toggler="#mobileSearch">
        <ToolkitProvider
          keyField="sensorId"
          data={props.alarmList}
          columns={columns}
          search={{
            afterSearch,
          }}
        >
          {(props) => (
            <div>
              <InputGroup>
                <Input
                  innerRef={inputRef}
                  value={props.searchProps.searchText}
                  onChange={(e) => props.searchProps.onSearch(e.target.value)}
                />
                <InputGroupAddon addonType="append">
                  <Button onClick={() => props.searchProps.onSearch('')}>
                    Clear
                  </Button>
                </InputGroupAddon>
              </InputGroup>
              <div style={{ display: 'none' }}>
                <BootstrapTable {...props.baseProps} />
              </div>
            </div>
          )}
        </ToolkitProvider>
      </UncontrolledCollapse>
    </div>
  );
}

export default MobileSearch;
